import { InvitationState, INVITATION_STATE_KEY } from './invitation-reducer';

export enum INVITATION_ACTION_TYPE {
  SET_INVITATION_STATE = 'SET_INVITATION_STATE'
}

export type SetInvitationStateAction<KeyName extends keyof InvitationState> = {
  type: INVITATION_ACTION_TYPE.SET_INVITATION_STATE;
  payload: { key: KeyName, value: InvitationState[KeyName] };
};

export type InvitationActions = SetInvitationStateAction<INVITATION_STATE_KEY>;
